/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsCommunityFundTotalStaked } from "../../funcs/metricsGetApiV3MetricsCommunityFundTotalStaked.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3MetricsCommunityFundTotalStakedRequest$inboundSchema.optional(),
};

export const tool$metricsGetApiV3MetricsCommunityFundTotalStaked:
  ToolDefinition<typeof args> = {
    name: "metrics-get-api-v3-metrics-community-fund-total-staked",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await metricsGetApiV3MetricsCommunityFundTotalStaked(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
